import { useContext } from "react";
import { TypographyH2, TypographyH3, TypographyP } from "./Typography";
import PilotCrossSection from "./ui/images/pilotCrossSection.png";
import { LanguageContext } from "./languageContext";
import {
  BusFront,
  ChartColumnStacked,
  GitCompareArrows,
  Timer,
} from "lucide-react";
import { HeaderIds } from "src/helpers/uiConstants";
import LazyScroll from "./ui/LazyScroll";

export default function ExistingConditions() {
  const { translate } = useContext(LanguageContext);
  return (
    <>
      <div className="space-y-4 mb-[80px] bg-[#f5f5f5] border border-[#e0e0e0] rounded-3xl p-4 md:p-8">
        <TypographyH3 textId="existingConditionsTitle" />
        <TypographyP textId="existingConditionsCaption" />
        <figure className="space-y-4">
          <figcaption>
            <TypographyP className="font-bold" textId="crossSectionTitle" />
          </figcaption>
          <LazyScroll height="196px">
            <div className="overflow-x-auto italic">
              <img
                className="min-w-[770px]"
                src={PilotCrossSection}
                alt={translate("existingConditionsCrossSectionAlt")}
              />
              <div className="flex">
                {[
                  {
                    width: "140px",
                    distance: translate("15Feet"),
                    label: translate("sidewalk"),
                  },
                  {
                    width: "72px",
                    distance: translate("8Feet"),
                    label: translate("curbLane"),
                  },
                  {
                    width: "97px",
                    distance: translate("10.25Feet"),
                    label: translate("driveLane"),
                  },
                  { width: "18px", distance: translate("2Feet"), label: "" },
                  {
                    width: "56px",
                    distance: translate("6Feet"),
                    label: translate("bikeLane"),
                  },
                  {
                    width: "56px",
                    distance: translate("6Feet"),
                    label: translate("bikeLane"),
                  },
                  { width: "18px", distance: translate("2Feet"), label: "" },
                  {
                    width: "97px",
                    distance: translate("10.25Feet"),
                    label: translate("driveLane"),
                  },
                  {
                    width: "72px",
                    distance: translate("8Feet"),
                    label: translate("curbLane"),
                  },
                  {
                    width: "140px",
                    distance: translate("15Feet"),
                    label: translate("sidewalk"),
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="text-center bg-[#EAE9E7] py-1"
                    style={{ maxWidth: item.width, minWidth: item.width }}
                  >
                    <div>
                      {item.distance}{" "}
                      <span className="sr-only">
                        {translate("feetDistanceUnit")}
                      </span>
                    </div>
                    <div>{item.label}</div>
                  </div>
                ))}
                {/* <div>15'</div>
                  <div>Sidewalk</div>
                </div>
                <div className="border-red-300 border min-w-[70px]">
                  <div>8'</div>
                  <div>Curb lane</div>
                </div>
                <div className="border-red-300 border min-w-[97px]">
                  <div>10 1/4'</div>
                  <div>Drive lane</div>
                </div>
                <div className="border-red-300 border min-w-[18px]">
                  <div>2'</div>
                </div>
                <div className="border-red-300 border min-w-[55px]">
                  <div>6'</div>
                  <div>Bike lane</div>
                </div>
                <div className="border-red-300 border min-w-[55px]">
                  <div>6'</div>
                  <div>Bike lane</div>
                </div>
                <div className="border-red-300 border min-w-[18px]">
                  <div>2'</div>
                </div>
                <div className="border-red-300 border min-w-[97px]">
                  <div>10 1/4'</div>
                  <div>Drive lane</div>
                </div>
                <div className="border-red-300 border min-w-[70px]">
                  <div>8'</div>
                  <div>Curb lane</div>
                </div>
                <div className="border-red-300 border min-w-[140px]">
                  <div>15'</div>
                  <div>Sidewalk</div>
                </div> */}
              </div>
            </div>
          </LazyScroll>
        </figure>
      </div>
      <div className="space-y-8">
        <TypographyH2
          id={HeaderIds.whatWeMeasuredHeader}
          textId="whatWeMeasuredTitle"
        />
        <TypographyP textId="whatWeMeasuredDescription" />

        <div className="grid grid-cols-12 gap-6">
          {[
            {
              icon: <GitCompareArrows height={24} width={24} />,
              title: translate("volumeToCapacityRatios"),
              description: translate("volumeToCapacityRatiosDescription"),
            },
            {
              icon: <Timer height={24} width={24} />,
              title: translate("travelTime"),
              description: translate("travelTimeDescription"),
            },
            {
              icon: <BusFront height={24} width={24} />,
              title: translate("transitDelay"),
              description: translate("transitDelayDescription"),
            },
            {
              icon: <ChartColumnStacked height={24} width={24} />,
              title: translate("sideStreetVolumes"),
              description: translate("sideStreetVolumesDescription"),
            },
          ].map(({ icon, title, description }, index) => (
            <div
              key={title + description + index}
              className="flex col-span-12 md:col-span-6 max-w-[300px] space-x-4"
            >
              <div>{icon}</div>
              <div className="space-y-1">
                <p className="font-bold">{title}</p>
                <p>{description}</p>
              </div>
            </div>
          ))}
        </div>
        <TypographyP textId="timesStudied" />
      </div>
    </>
  );
}
